import { BN } from '@drift-labs/sdk';

export const sortRecordsByTs = <T extends { ts: BN }[]>(
	records: T | undefined,
	direction: 'asc' | 'desc' = 'desc'
) => {
	if (!records || !records?.length) return [];

	return direction === 'desc'
		? [...records].sort((a, b) => b.ts.toNumber() - a.ts.toNumber())
		: [...records].sort((a, b) => a.ts.toNumber() - b.ts.toNumber());
};
